import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Flex from "./Flex";
import { observer } from '@core-ui/react-mobx-state';
import Text from './Text';
import { Colors } from '../colors';
export const TokenValue = observer((props) => {
    const { value, icon, reverse, fontSize = 14, color, style } = props;
    return (_jsxs(Flex, { width: "fit-content", flexDirection: reverse ? "row-reverse" : 'row', alignItems: 'center', children: [icon ? icon : "", _jsx(Text, { mr: reverse ? 0.5 : 0, ml: reverse ? 0 : 0.5, color: color || Colors.textWhite, whiteSpace: "nowrap", style: { fontWeight: 550, fontSize, ...style }, children: value })] }));
});
